module.exports = __webpack_public_path__ + "img/136-iran.ca2a056b.svg";